if (!customElements.get('lift-catalogue')) {
  customElements.define('lift-catalogue', class extends HTMLElement {
    connectedCallback() {
      this.onclick = event => {
        const button = event.target.closest('[data-range-filter]');
        if (!button || !this.contains(button)) return;
        const category = button.dataset.rangeFilter;
        this.querySelectorAll('[data-range-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-range-category]').forEach(card => {
          card.hidden = category !== 'all' && card.dataset.rangeCategory !== category;
        });
      };
    }
  });
}
